'use client';
import { FC } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  // DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  // DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';

import { Menu, X } from 'lucide-react';
import Logo from '../Logo/Logo';


// import MobileNavItem from './MobileNavItem';
import { NAVIGATION_DATA } from '@/data/defaultValue';
import MobileNavItem from './MobileNavItem';




interface MobileBarProps {
  className?: string;
}

const MobileBar: FC<MobileBarProps> = () => {

  return (
    <Drawer>
      <DrawerTrigger>
        <Menu />
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className='noto-sans-bengali'>
          <div className='flex justify-between items-center'>
            <Logo />
            <DrawerClose>
              <X />
            </DrawerClose>
          </div>
          {/* <DrawerTitle>
            <h5>বাংলা কন্টেন্ট রাইটিং কোর্স</h5>
          </DrawerTitle>
          <DrawerDescription>
            <p>
              মাতৃভাষার বাংলার প্রতি আমাদের ভালোবাসা আজন্মকাল। বাংলাভাষা আমাদের
              জন্য গর্বের, অহংকারের। শুধু ইংরেজি নয়, বাংলা লেখার চাহিদা বাড়ছে
              দিন দিন। বাংলা লেখা নিয়েই চমৎকার একটি ক্যারিয়ার গড়ার সুযোগ আছে।{' '}
            </p>
          </DrawerDescription> */}
        </DrawerHeader>
        <DrawerFooter className='flex flex-col poppins'>
    

          {NAVIGATION_DATA.map((item)=> <MobileNavItem  key={item.id} menuItem={item} />)}

     
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileBar;
